// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Popular_wrapper__1NF-G","title-container":"Popular_title-container__1gtFB"};